import { DEFAULT_EMPTY_VALUE } from 'features/my-zone/consts';

export const tableDateFormatter = (value?: string, includeTime = true) => {
    if (!value) {
        return '';
    }

    const dateFormat = new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        ...(includeTime
            ? {
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true,
              }
            : {}),
    });

    return dateFormat.format(new Date(value));
};

export const tableDateComparator = (a: string, b: string) =>
    new Date(a).getTime() - new Date(b).getTime();

export const tableNumberFormatter = (value: number) => {
    return value === 0 ? DEFAULT_EMPTY_VALUE : value.toString();
};
